<template>
	<div class="container_page">
		<a-form layout="inline">
			<a-form-item label="搜索">
				<a-input placeholder="请输入关键字" v-model="filterData.keywords" />
			</a-form-item>
			<a-form-item>
				<a-button icon="search" class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12"  @click="toSearch(false)">重置</a-button>
				<a-button icon="plus" type="primary" v-if="hasPermission('FCTORY_BAND_ADD')" @click="toAdd">新建</a-button>
			</a-form-item>
		</a-form>
		<!-- 分类标签栏 -->
		<div class="cate">
			<a-radio-group v-model="filterData.businessType" button-style="solid" @change="changeTab">
				<a-radio-button value="FACTORY">
					工厂
				</a-radio-button>
				<a-radio-button value="BRABD">
					品牌
				</a-radio-button>
				<a-radio-button value="SUPPLIER">
					供应商
				</a-radio-button>
			</a-radio-group>
		</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="businessLogoRender" slot-scope="text, record">
				<viewer :images="[record.businessLogo]">
					<div class="er_content">
						<img class="er_content_img" :src="img" v-for="(img,index) in [record.businessLogo]"
							:key="index">
					</div>
				</viewer>
			</template>
			<template slot="businessStatusRender" slot-scope="text, record">
				<a-switch :checked="record.businessStatus"
					@change="(checked) => handlePublishChange(checked, record)" />
			</template>
			<template slot="action" slot-scope="text, record">
				<span v-if="hasPermission('FCTORY_BAND_EDIT')"><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm v-if="hasPermission('FCTORY_BAND_DEL')" title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
					<a-button type="link">删除</a-button>
				</a-popconfirm>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model ref="formRef" :rules="rules" :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="分类" prop="businessType" required>
							<a-radio-group name="radioGroup" v-model="editModel.businessType">
								<a-radio value="FACTORY"> 工厂 </a-radio>
								<a-radio value="BRABD"> 品牌 </a-radio>
								<a-radio value="SUPPLIER"> 供应商 </a-radio>
							</a-radio-group>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="logo" prop="businessLogo" required>
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.businessLogo">
									<viewer :images="[editModel.businessLogo]">
										<div class="er_content">
											<img class="er_content_img" :src="img"
												v-for="(img,index) in [editModel.businessLogo]" :key="index">
										</div>
									</viewer>
								</div>
								<div class="again_upload_box ml12">
									<input type="file" accept="image/*" @change="handleUpdataFile" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width: 100px">
										<a-spin v-if="uploading" /> <span v-else>{{ editModel.businessLogo ? "重新上传" : "上传logo" }}</span>
									</div>
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="名称" prop="businessName" required>
							<a-input placeholder="请输入名称" style="width: 180px;" v-model="editModel.businessName" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="英文名称" prop="businessEnName" required>
							<a-input placeholder="请输入英文名称" style="width: 180px;" v-model="editModel.businessEnName" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		getBusinessEntitiesApi, //列表
		getBusinessEntityDetailApi, //详情  不知道从哪里点进去详情
		saveBusinessEntityApi, //编辑
		deleteBusinessEntityApi, //删除
		updateBusinessEntitySortApi, //？？？？不知道什么时候调用 还有状态的接口 暂时先不加
		updateBusinessEntityStatusApi,
	} from "../../api/index";
	import {
		ossUpload
	} from "../../utils/oss";
	export default {
		name: "cardsList",
		data() {
			return {
				uploading: false,
				activeTab: 'FACTORY',
				columns: [{
						title: '序号',
						dataIndex: 'sort',
						key: 'sort',
						customRender: (text, record, index) => {
							return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
						}
					},
					{
						title: '工厂编码',
						dataIndex: 'businessCode',
						key: 'businessCode',
					},
					{
						title: 'logo',
						dataIndex: 'businessLogo',
						key: 'businessLogo',
						scopedSlots: {
							customRender: "businessLogoRender"
						},
					},
					{
						title: '工厂名称',
						dataIndex: 'businessName',
						key: 'businessName',
					},
					{
						title: '状态',
						dataIndex: 'businessStatus',
						key: 'businessStatus',
						scopedSlots: {
							customRender: "businessStatusRender"
						},
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 10,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					giftCardId: 0,
					giftCardStatus: undefined,
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "新建其他标签信息",
					"businessId": 0, //工厂名称ID/品牌Id
					"businessLogo": "", //LOGO
					"businessName": "", //工厂名称/品牌名称
					"businessEnName": "", //工厂名称/品牌名称  英文
					"businessType": "FACTORY", //类型    FACTORY 工厂 、BRABD 品牌 、SUPPLIER 供应商
					onOk: () => {},
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					timeDate: [],
					keywords: "",
					businessType: "FACTORY"
				},
				rules: {
					businessType: [
						{ required: true, message: '请选择分类', trigger: 'change' }
					],
					businessLogo: [
						{ required: true, message: '请上传logo', trigger: 'change' }
					],
					businessName: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					businessEnName: [
						{ required: true, message: '请输入英文名称', trigger: 'blur' }
					],
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('fctory_band_spplierManage_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1);
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('fctory_band_spplierManage_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},

			// 【上架状态】：启用时：按钮点亮状态，单击切换为禁用时，系统提示“切换为禁用状态，则当前数据禁用，系统内不可选？”确认/取消；
			// 禁用时：按钮置灰状态，单击切换为启用状态时，系统提示“已切换为启用状态”。停留2秒消失
			handlePublishChange(checked, record) {
				console.log(checked, '看看这个是啥')
				if (checked == false) {
					const actionText = checked ? '启用' : '禁用';
					this.$confirm({
						title: '操作确认',
						content: `切换为${actionText}状态，则当前数据禁用，系统内不可选`,
						okText: '确定',
						cancelText: '取消',
						onOk: () => {
							// 走接口
							this.changeStatus(record, '1')
							record.businessStatus = !record.businessStatus
						},
						onCancel: () => {
							console.log('已取消操作');
						}
					});
				} else {
					record.businessStatus = !record.businessStatus
					this.$message.success('已切换为启用状态');
					// 这里可以调用接口更新状态
					this.changeStatus(record, '2')
					console.log('发布状态已更新为：', record.publishStatus);
				}

			},
			// 切换状态接口
			changeStatus(record, value) {
				updateBusinessEntityStatusApi({
						"businessId": record.businessId
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								value == '1' ? "状态更新成功" : "已切换为启用状态"
							);
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			},

			onTabChange(key) {
				console.log('Tab changed to:', key);
				this.activeTab = key;
				// 如果是接口请求数据，可以在这里调用接口
				this.getData(1);
			},
			changeTab(value) {
				console.log('Tab changed to:', value);
				this.filterData.businessType = value.target.value;
				this.getData();
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						businessType: "FACTORY"
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getBusinessEntitiesApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						keywords: this.filterData.keywords,
						businessType: this.filterData.businessType
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.editModel = {
					flag: true,
					title: "新建其他标签信息",
					businessId: 0,
					"businessLogo": '',
					"businessName": '',
					"businessEnName": '',
					"businessType": this.filterData.businessType,
					onOk: this.sureEdit,
				};
			},
			toEdit(data) {
				getBusinessEntityDetailApi({
						businessId: data.businessId,
					})
					.then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.editModel = {
								"flag": true,
								"title": "编辑",
								"businessId": result.businessId,
								"businessLogo": result.businessLogo, //LOGO
								"businessName": result.businessName, //工厂名称/品牌名称
								"businessEnName": result.businessEnName, //工厂名称/品牌名称  英文
								"businessType": result.businessType, //类型    FACTORY 工厂 、BRABD 品牌 、SUPPLIER 供应商
								onOk: this.sureEdit,
							};
						} else {
							console.log("res");
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			// 编辑
			sureEdit() {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return;
					saveBusinessEntityApi({
						"businessId": this.editModel.businessId, //工厂名称ID/品牌Id
						"businessLogo": this.editModel.businessLogo, //LOGO
						"businessName": this.editModel.businessName, //工厂名称/品牌名称
						"businessEnName": this.editModel.businessEnName, //工厂名称/品牌名称  英文
						"businessType": this.editModel.businessType, //类型    FACTORY 工厂 、BRAND 品牌 、SUPPLIER 供应商
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.businessId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
				});
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteBusinessEntityApi({
						businessId: record.businessId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						if (file.size > 3 * 1024 * 1024) {
							this.$message.warning('图片大小不能超过3MB');
							e.target.value = '';
							return;
						}
						this.uploading = true;
						ossUpload(file, '', 'image/').then((res) => {
							this.editModel.businessLogo = res.url;
							this.uploading = false;
							if (this.$refs.formRef) {
								this.$refs.formRef.validateField('businessLogo');
							}
						}).catch(err => {
							this.uploading = false;
							console.log("上传失败", err);
							this.$message.error('图片上传失败')
						});
					}
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.container_page {
		padding: 20px;
		background: #ffffff;

		.cate {
			margin: 20px 0;

			.ant-radio-button-wrapper {
				width: 100px !important;
				text-align: center !important;
			}
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>
